import React, { useMemo } from 'react';
import { useTranslation, isMobile, BetStatus } from '@pascal/pascal-core';

import { globalTranslationKeys } from '../../../enums';

const mockArray = [
  { jetIndex: 0, odd: null, jetNumber: 1 },
  { jetIndex: 1, odd: null, jetNumber: 2 },
  { jetIndex: 2, odd: null, jetNumber: 1 },
];

export const GameSpecificCheckHashPopupTopSection = ({ isFromBetHistory, currentData, t }) => {
  const orderedRoundData = useMemo(() => {
    const arr = [];
    if (currentData.roundData) {
      currentData.roundData.forEach((item, index) => {
        arr[item.jetIndex] = { ...item, jetIndex: index, blowUpIndex: index + 1 };
      });
      return arr;
    }

    if (Array.isArray(currentData.result)) {
      currentData.result.forEach((item, index) => {
        arr[item.jetIndex] = {
          ...item,
          jetIndex: index,
          blowUpIndex: index + 1,
          highestOdd: currentData.odd,
        };
      });
      return arr;
    }
    return mockArray;
  }, [currentData]);

  return (
    <div className='odd-g-result-popup-wrp'>
      <div className='round-jets-container'>
        <div className='jets-items-blocks'>
          {orderedRoundData.map((item, index) => (
            <div className='jets-items' key={item.jetIndex}>
              <div
                className={`jet-btn-text type-${item.blowUpIndex} ${
                  (!item.odd && !isFromBetHistory) ||
                  (isFromBetHistory && item.jetIndex !== currentData?.additionalParams.index) ||
                  (!isFromBetHistory && item.highestOdd && item.highestOdd !== item.odd)
                    ? 'disabled'
                    : ''
                }`}
              >
                {item.odd ? <span className='jet-btn-text-word'>{`x${item.odd}`}</span> : <></>}
              </div>
              <div
                className={`jets-items-bg type-${item.blowUpIndex || mockArray[index].jetNumber} ${
                  (!item.odd && !isFromBetHistory) ||
                  (isFromBetHistory && item.jetIndex !== currentData?.additionalParams.index) ||
                  (!isFromBetHistory && item.highestOdd && item.highestOdd !== item.odd)
                    ? 'disabled'
                    : ''
                }`}
              />
            </div>
          ))}
        </div>
        {isFromBetHistory && (
          <div className={`round-jets-currency type-${currentData?.additionalParams.index + 1}`}>
            <div
              className={`round-jets-currency-inner ${
                currentData.status === BetStatus.Lose ? 'lose' : 'win'
              }`}
            >
              <span className='round-jets-cashout-text'>{t(globalTranslationKeys.CashOut)}</span>
              <span className='round-jets-currency-text'>{`x${currentData.odd}`}</span>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export const AboutHashInnerContent = ({ t }) => {
  return (
    <>
      {isMobile() && <p className='pr-f-text'>{t(globalTranslationKeys.FairnessModalTitle)}</p>}
      <p className='pr-f-text'>{t('FAIRNESS_P1')}</p>
      <p className='pr-f-text w-b-ba'>
        8860731B4F9523DD3A1AA686A237BB89CC5EC01448ADFFE6FFE64F12E3015C648904D3761689EA0B642B8E0A8A250ADA0773247B792541B2EE4FD89EFFA3283B
      </p>
      <p className='pr-f-text'>{t('FAIRNESS_P2')}</p>
      <p className='pr-f-text'>{t('FAIRNESS_P3')}</p>
      <p className='pr-f-text'>{t('FAIRNESS_P4')}</p>

      <ol className='pr-f-text'>
        <li className='pr-f-text'>{t('FAIRNESS_P5')}</li>
        <li className='pr-f-text'>{t('FAIRNESS_P6')}</li>
        <li className='pr-f-text'>{t('FAIRNESS_P7')}</li>
        <li className='pr-f-text'>{t('FAIRNESS_P8')}</li>
      </ol>
      <p className='pr-f-text'>{t('FAIRNESS_P9')}</p>
      <p className='pr-f-text'>{t('FAIRNESS_P10')}</p>
      <p className='pr-f-text'>
        2182537_x99.35/x88.25/x1057_ Fighters_5122fbfa-17e4-4fa4-8618- 016e3bc3bb5f
      </p>
      <p className='pr-f-text'>{t('FAIRNESS_P11')}</p>
      <p className='pr-f-text w-b-ba'>
        8860731B4F9523DD3A1AA686A237BB89CC5EC01448ADFFE6FFE64F12E3015C648904D3761689EA0B642B8E0A8A250ADA0773247B792541B2EE4FD89EFFA3283B
      </p>
      <p className='pr-f-text'>{t('FAIRNESS_P12')}</p>
    </>
  );
};

export const HelpPopupContent = () => {
  const t = useTranslation();
  const { CancelationMessage1, MalfunctionMessage2, Rtp } = globalTranslationKeys;

  return (
    <>
      <p>{t('GAME_RULES_P1')}</p>
      <br />
      <p>{t('GAME_RULES_P2')}</p>
      <br />
      <div className='logo-about-game'>
        <div className='logo-about-game-inner' />
      </div>
      <b>
        <p>{t('GAME_RULES_P3')}</p>
      </b>
      <br />
      <p>{t('GAME_RULES_P4')}</p>
      <br />

      <p>{t('GAME_RULES_P5')}</p>
      <br />

      <p>{t('GAME_RULES_P6')}</p>
      <br />
      <p>
        {t(CancelationMessage1)}
        <br />
        {t(MalfunctionMessage2)}
      </p>
      <br />
      <p>{t(Rtp)}</p>
    </>
  );
};

export const AutoBetPopUpContent = () => {
  const t = useTranslation();
  return (
    <>
      <b>
        <p>{t('GAME_RULES_P9')}</p>
      </b>
      <br />
      <p>{t('GAME_RULES_P10')}</p>
      <br />
      <p>{t('GAME_RULES_P11')}</p>
      <br />
      <p>{t('GAME_RULES_P12')}</p>
      <div className='auto-bet-bg-img-container'>
        <div className='auto-bet-bg-img'>
          <p className='auto-bet-info-text top'>{t(globalTranslationKeys.AutoBet)}</p>
          <p className='auto-bet-info-text bottom'>{t(globalTranslationKeys.AutoBet)}</p>
        </div>
      </div>
    </>
  );
};

export const AutoCashOutPopUpContent = () => {
  const t = useTranslation();
  return (
    <>
      <b>
        <p>{t('GAME_RULES_P7')}</p>
      </b>
      <br />
      <p>{t('GAME_RULES_P8')}</p>
      <br />
      <div className='auto-cashout-bg-img-container'>
        <div className='auto-cashout-bg-img'>
          <p className='auto-cashout-info-text'>{t(globalTranslationKeys.AutoCashOut)}</p>
        </div>
      </div>
    </>
  );
};

export const HalfCashOutPopUpContent = () => {
  const t = useTranslation();
  return (
    <>
      <b>
        <p>{t('GAME_RULES_P13')}</p>
      </b>
      <br />
      <p>{t('GAME_RULES_P14')}</p>
    </>
  );
};
